/* AB ab_flex_offer — sunsets 2026-10-31, delete src/pages/AB_FlexOfferSuivi/ */
/* eslint-disable no-restricted-syntax --
 * Self-contained CSS string reproducing the standalone POC's design tokens.
 * Hex + rgba() are intentional (not using paletteColors here to keep the
 * dashboard look-and-feel isolated from the RM App theme). */

/**
 * CSS for the Flex Offer Suivi page, copied from the original standalone POC.
 * Every class is prefixed `fo-` and all element selectors are scoped to `.fo-root`
 * so styles can't leak into the rest of the app.
 */
export const AB_FLEX_OFFER_SUIVI_CSS = `
.fo-root {
    --fo-green: #00B48D;
    --fo-green-dark: #00967A;
    --fo-green-light: #E6F7F4;
    --fo-navy: #1B2E45;
    --fo-bg: #F4F6F9;
    --fo-surface: #FFFFFF;
    --fo-border: #E2E8F0;
    --fo-border-strong: #CBD5E1;
    --fo-text-primary: #1B2E45;
    --fo-text-secondary: #64748B;
    --fo-text-muted: #94A3B8;
    --fo-red: #DC2626;
    --fo-red-light: #FEF2F2;
    --fo-orange: #D97706;
    --fo-orange-light: #FFFBEB;
    --fo-blue: #2563EB;
    --fo-blue-light: #EFF6FF;
    --fo-gray-light: #F8FAFC;
    --fo-radius: 10px;
    --fo-radius-sm: 6px;
    --fo-shadow: 0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04);

    font-family: 'Source Sans 3', system-ui, -apple-system, sans-serif;
    background: var(--fo-bg);
    color: var(--fo-text-primary);
    font-size: 14px;
    line-height: 1.5;
    min-height: 100vh;
}

.fo-root * { box-sizing: border-box; }

.fo-header {
    background: var(--fo-surface);
    border-bottom: 1px solid var(--fo-border);
    height: 60px;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 100;
}

.fo-header-left { display: flex; align-items: center; gap: 20px; }

.fo-logo { display: flex; align-items: center; gap: 9px; text-decoration: none; flex-shrink: 0; }
.fo-logo svg { display: block; }

.fo-header-sep { width: 1px; height: 22px; background: var(--fo-border-strong); }

.fo-header-product { font-size: 14px; font-weight: 500; color: var(--fo-text-secondary); }

.fo-header-right { display: flex; align-items: center; gap: 12px; }

.fo-agency-chip {
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--fo-bg);
    border: 1px solid var(--fo-border-strong);
    padding: 5px 12px 5px 6px;
    border-radius: 20px;
}

.fo-agency-avatar {
    width: 26px; height: 26px;
    background: var(--fo-navy);
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    color: white;
    font-size: 11px; font-weight: 700; letter-spacing: 0.3px;
}

.fo-agency-label {
    font-size: 13px; font-weight: 600;
    color: var(--fo-text-primary);
    max-width: 220px;
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

.fo-main { max-width: 1320px; margin: 0 auto; padding: 32px; }

.fo-page-header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 24px;
}

.fo-page-title { font-size: 20px; font-weight: 700; color: var(--fo-navy); margin-bottom: 4px; }

.fo-page-meta { display: flex; align-items: center; gap: 6px; font-size: 13px; color: var(--fo-text-muted); }

.fo-sync-dot {
    width: 7px; height: 7px;
    border-radius: 50%;
    background: var(--fo-green);
    animation: fo-pulse 2.5s ease-in-out infinite;
}

@keyframes fo-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
}

.fo-kpi-row {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 16px;
    margin-bottom: 24px;
}

.fo-kpi {
    background: var(--fo-surface);
    border: 1px solid var(--fo-border);
    border-radius: var(--fo-radius);
    padding: 20px 22px;
    box-shadow: var(--fo-shadow);
    position: relative;
    overflow: hidden;
}

.fo-kpi::after {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 3px; height: 100%;
    background: var(--fo-border);
    border-radius: 3px 0 0 3px;
}

.fo-kpi.fo-kpi-main::after { background: var(--fo-green); }
.fo-kpi.fo-kpi-main-expo::after { background: var(--fo-navy); width: 4px; }

.fo-kpi-label {
    font-size: 11px; font-weight: 700;
    text-transform: uppercase; letter-spacing: 0.7px;
    color: var(--fo-text-muted);
    margin-bottom: 10px;
}

.fo-kpi-number {
    font-size: 36px; font-weight: 700; line-height: 1;
    color: var(--fo-navy);
    margin-bottom: 6px;
    font-variant-numeric: tabular-nums;
}

.fo-kpi-hint { font-size: 12px; color: var(--fo-text-muted); }

.fo-expo-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18px;
    margin-top: 4px;
}

.fo-expo-block-label {
    font-size: 11px; font-weight: 700;
    text-transform: uppercase; letter-spacing: 0.6px;
    color: var(--fo-text-muted);
    margin-bottom: 4px;
}

.fo-expo-block-value {
    font-size: 28px; font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: var(--fo-navy);
    line-height: 1.1;
}

.fo-expo-block.fo-is-primary .fo-expo-block-value { color: var(--fo-green); font-size: 30px; }

.fo-expo-block-hint {
    font-size: 11.5px; color: var(--fo-text-muted);
    margin-top: 3px; line-height: 1.35;
}

.fo-card {
    background: var(--fo-surface);
    border: 1px solid var(--fo-border);
    border-radius: var(--fo-radius);
    box-shadow: var(--fo-shadow);
}

.fo-toolbar {
    padding: 14px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    border-bottom: 1px solid var(--fo-border);
}

.fo-toolbar-left { display: flex; align-items: center; gap: 10px; flex: 1; }

.fo-search-wrap { position: relative; flex: 1; max-width: 300px; }

.fo-search-icon {
    position: absolute;
    left: 10px; top: 50%;
    transform: translateY(-50%);
    color: var(--fo-text-muted);
    pointer-events: none;
}

.fo-root input[type="text"],
.fo-root select {
    font-family: inherit;
    font-size: 13.5px;
    color: var(--fo-text-primary);
    background: var(--fo-bg);
    border: 1px solid var(--fo-border);
    border-radius: var(--fo-radius-sm);
    outline: none;
    transition: border-color 0.15s, box-shadow 0.15s;
}

.fo-root input[type="text"]:focus,
.fo-root select:focus {
    border-color: var(--fo-green);
    box-shadow: 0 0 0 3px rgba(0,180,141,0.12);
    background: white;
}

.fo-search-input { width: 100%; padding: 7px 12px 7px 32px; }
.fo-search-input::placeholder { color: var(--fo-text-muted); }

.fo-root select {
    padding: 7px 32px 7px 10px;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
}

.fo-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border-radius: var(--fo-radius-sm);
    font-size: 13.5px;
    font-family: inherit;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;
    border: 1px solid var(--fo-border);
    background: var(--fo-surface);
    color: var(--fo-text-primary);
}
.fo-btn:hover { background: var(--fo-bg); border-color: var(--fo-border-strong); }

.fo-table-scroll { overflow-x: auto; }

.fo-root table { width: 100%; border-collapse: collapse; }
.fo-root thead { background: var(--fo-gray-light); }
.fo-root th {
    padding: 10px 16px;
    text-align: left;
    font-size: 11px; font-weight: 700;
    text-transform: uppercase; letter-spacing: 0.65px;
    color: var(--fo-text-secondary);
    white-space: nowrap;
    cursor: pointer; user-select: none;
    border-bottom: 1px solid var(--fo-border);
}
.fo-root th:hover { color: var(--fo-navy); }
.fo-root th.fo-sorted { color: var(--fo-green-dark); }

.fo-sort-icon { display: inline-block; margin-left: 3px; font-size: 10px; opacity: 0.35; }
.fo-root th.fo-sorted .fo-sort-icon { opacity: 1; }

.fo-root td {
    padding: 12px 16px;
    border-bottom: 1px solid var(--fo-border);
    vertical-align: middle;
    font-size: 13.5px;
}
.fo-root tr:last-child td { border-bottom: none; }
.fo-root tbody tr { transition: background 0.1s; }
.fo-root tbody tr:hover td { background: #FAFCFF; }

.fo-link-dossier {
    font-weight: 600;
    color: var(--fo-green-dark);
    text-decoration: none;
    font-size: 13px;
}
.fo-link-dossier:hover { text-decoration: underline; }

.fo-destination-cell { font-weight: 500; }

.fo-amount-cell { font-weight: 600; font-variant-numeric: tabular-nums; text-align: right; }

.fo-badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 8px;
    border-radius: 20px;
    font-size: 11.5px; font-weight: 600;
    white-space: nowrap;
}

.fo-badge-ok      { background: var(--fo-green-light);  color: #006B55; }
.fo-badge-warning { background: var(--fo-orange-light); color: #92400E; }
.fo-badge-urgent  { background: var(--fo-red-light);    color: #991B1B; }
.fo-badge-past    { background: var(--fo-gray-light);   color: var(--fo-text-muted); border: 1px solid var(--fo-border); }

.fo-status-badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 9px;
    border-radius: var(--fo-radius-sm);
    font-size: 11.5px; font-weight: 600;
}

.fo-status-not-travelled { background: var(--fo-gray-light); color: var(--fo-text-muted); border: 1px solid var(--fo-border); }
.fo-status-travelled     { background: var(--fo-green-light); color: #006B55; }
.fo-status-cancelled     { background: var(--fo-orange-light); color: #92400E; }

.fo-pay-solde    { background: #E7F0FC; color: #1E40AF; }
.fo-pay-partiel  { background: #FEF3C7; color: #92400E; }
.fo-pay-acompte  { background: var(--fo-gray-light); color: var(--fo-text-muted); border: 1px solid var(--fo-border); }

.fo-trip-tag {
    display: inline-flex;
    align-items: center;
    margin-left: 6px;
    padding: 2px 7px;
    border-radius: 10px;
    font-size: 10.5px; font-weight: 600;
    text-transform: uppercase; letter-spacing: 0.4px;
}
.fo-trip-travelling { background: #EDE9FE; color: #6D28D9; }
.fo-trip-travelled  { background: var(--fo-gray-light); color: var(--fo-text-muted); border: 1px solid var(--fo-border); }

.fo-root tr.fo-is-travelled td { opacity: 0.55; }

.fo-checkbox-wrap {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 7px 10px;
    border-radius: var(--fo-radius-sm);
    cursor: pointer; user-select: none;
    font-size: 13px;
    color: var(--fo-text-secondary);
    transition: background 0.15s;
}
.fo-checkbox-wrap:hover { background: var(--fo-bg); color: var(--fo-text-primary); }
.fo-checkbox-wrap input {
    width: 15px; height: 15px;
    accent-color: var(--fo-green);
    cursor: pointer;
}

.fo-table-footer {
    padding: 10px 18px;
    font-size: 12px;
    color: var(--fo-text-muted);
    border-top: 1px solid var(--fo-border);
    background: var(--fo-gray-light);
    border-radius: 0 0 var(--fo-radius) var(--fo-radius);
}

.fo-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 72px 32px;
    color: var(--fo-text-secondary);
    font-size: 14px;
}

.fo-spinner {
    width: 20px; height: 20px;
    border: 2px solid var(--fo-border);
    border-top-color: var(--fo-green);
    border-radius: 50%;
    animation: fo-spin 0.7s linear infinite;
    flex-shrink: 0;
}

@keyframes fo-spin { to { transform: rotate(360deg); } }

.fo-empty-state { padding: 72px 32px; text-align: center; }

.fo-empty-icon {
    width: 52px; height: 52px;
    background: var(--fo-green-light);
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 16px;
}

.fo-empty-title { font-size: 16px; font-weight: 600; color: var(--fo-navy); margin-bottom: 6px; }
.fo-empty-desc { font-size: 13px; color: var(--fo-text-secondary); max-width: 380px; margin: 0 auto; }

.fo-error-state { padding: 72px 32px; text-align: center; }

.fo-error-icon {
    width: 52px; height: 52px;
    background: var(--fo-red-light);
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 16px;
    color: var(--fo-red);
}

.fo-error-title { font-size: 16px; font-weight: 600; color: var(--fo-navy); margin-bottom: 8px; }

.fo-error-desc {
    font-size: 13px; color: var(--fo-text-secondary);
    max-width: 420px; margin: 0 auto; line-height: 1.6;
}

@media (max-width: 960px) {
    .fo-kpi-row { grid-template-columns: 1fr 1fr; }
    .fo-main { padding: 20px 16px; }
    .fo-header { padding: 0 16px; }
    .fo-header-product { display: none; }
    .fo-expo-grid { grid-template-columns: 1fr; gap: 12px; }
}

@media (max-width: 600px) {
    .fo-kpi-row { grid-template-columns: 1fr; }
}
`;
